import React from 'react';
import { Subsection } from '@fourthwall/components';
import { FeatureFlagDecorator, useDashboardFeatureFlags } from '@components';
import dayjs from 'dayjs';
import { useFindOngoingCreatorChallengeQuery } from './queries/useCurrentCreatorChallengeQuery';
import { JoinCreatorChallengeContainer } from './JoinCreatorChallengeContainer';
import { CreatorChallengeSuccessContainer } from './CreatorChallengeSuccessContainer';
import { OngoingCreatorChallengeContainer } from './OngoingCreatorChallengeContainer';
import { CreatorChallengeFailureContainer } from './CreatorChallengeFailureContainer';
const isStillOngoing = (endDate) => {
    const now = dayjs();
    const end = dayjs(endDate);
    return now.isBefore(end);
};
const CHALLENGE_REWARD = '$50';
export const CreatorChallengeRecommendation = ({ onDismiss }) => {
    const { dashboardFeatureFlags } = useDashboardFeatureFlags();
    const { findOngoingCreatorChallengeQuery } = useFindOngoingCreatorChallengeQuery();
    const progress = !findOngoingCreatorChallengeQuery?.isSuccess ||
        !findOngoingCreatorChallengeQuery?.data?.challenges?.length
        ? null
        : findOngoingCreatorChallengeQuery.data.challenges[0];
    const recommendationStrategy = () => {
        if (!progress) {
            return React.createElement(JoinCreatorChallengeContainer, { challengeReward: CHALLENGE_REWARD });
        }
        if (progress.expected > progress.current && isStillOngoing(progress.endAt)) {
            return React.createElement(OngoingCreatorChallengeContainer, { ...progress, reward: CHALLENGE_REWARD });
        }
        if (progress.expected <= progress.current)
            return (React.createElement(CreatorChallengeSuccessContainer, { numberOfOrders: progress.expected, reward: CHALLENGE_REWARD, onDismiss: onDismiss }));
        return React.createElement(CreatorChallengeFailureContainer, { ...progress, onDismiss: onDismiss });
    };
    return (React.createElement(FeatureFlagDecorator, { ...dashboardFeatureFlags.creatorChallenge, wrapper: Subsection }, recommendationStrategy()));
};
